/* One switch in the address, read once per document: ?singlePage=true hides every navigation
   surface and leaves the page alone on screen. It is read at boot rather than followed through
   the router because the surfaces that ask for it — a Teams channel tab showing one analytics
   page, a page framed somewhere else — set the address once and expect the whole visit to keep
   the shape they asked for. */
const getInitialRuntimeSinglePage = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const value = String(new URLSearchParams(window.location.search).get('singlePage') || '')
      .trim()
      .toLowerCase();

    return value === 'true' || value === '1';
  } catch {
    return false;
  }
};

export default getInitialRuntimeSinglePage;
